import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'


const _hoisted_1 = { class: "popup-overlay" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-header" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordPop',
  emits: ["passwordChk", "closePop"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const password = ref('');
const submitPassword = () => {
    emit("passwordChk", password.value)
        console.log(password.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "popup_title" }, "인감 비밀번호", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closePop'))),
          class: "close_icon"
        })
      ]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(submitPassword, ["prevent"]),
        autocomplete: "off"
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("input", {
          type: "text",
          name: "fake_user",
          style: {"display":"none"},
          autocomplete: "off"
        }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("input", {
          type: "password",
          name: "fake_pwd",
          style: {"display":"none"},
          autocomplete: "off"
        }, null, -1)),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          placeholder: "비밀번호",
          autocomplete: "new-password"
        }, null, 512), [
          [_vModelText, password.value]
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("button", { type: "submit" }, "확인", -1))
      ], 32)
    ])
  ]))
}
}

})